import React, { useState, useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';

const ALL_HOME_SCROLL_SECTIONS = [
  { id: 'offers', label: 'عروض' },
  { id: 'coupons', label: 'كوبونات' },
  { id: 'home-new-restaurants', label: 'جديد على يسلمو' },
  { id: 'home-lowest-delivery', label: 'توصيل سريع' },
  { id: 'exclusive', label: 'كل المطاعم' },
];

const MARKET_HOME_SCROLL_SECTIONS = [
  { id: 'market-categories', label: 'تصنيفات الماركت' },
  { id: 'coupons', label: 'كوبونات' },
  { id: 'home-new-markets', label: 'جديد على يسلمو' },
  { id: 'home-lowest-delivery-markets', label: 'توصيل سريع' },
  { id: 'exclusive-market', label: 'كل الماركت' },
];

const SectionScrollNavigation = () => {
  const location = useLocation();
  const [activeSection, setActiveSection] = useState('categories');

  const sections = useMemo(() => {
    if (location.pathname.includes('market-home-page')) {
      return MARKET_HOME_SCROLL_SECTIONS;
    }
    return ALL_HOME_SCROLL_SECTIONS;
  }, [location.pathname]);

  const handleSectionClick = (sectionId) => {
    setActiveSection(sectionId);
    const element = document.getElementById(sectionId);
    if (element) {
      element?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY + 200;

      for (const section of sections) {
        const element = document.getElementById(section?.id);
        if (element) {
          const offsetTop = element?.offsetTop;
          const offsetBottom = offsetTop + element?.offsetHeight;

          if (scrollPosition >= offsetTop && scrollPosition < offsetBottom) {
            setActiveSection(section?.id);
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [sections]);

  return (
    <div className="section-scroll-navigation">
      {sections.map((section) => (
        <button
          key={section?.id}
          className={`section-scroll-link ${activeSection === section?.id ? 'active' : ''}`}
          onClick={() => handleSectionClick(section?.id)}
        >
          {section?.label}
        </button>
      ))}
    </div>
  );
};

export default SectionScrollNavigation;
